import { Heading, Icon, List, ListIcon, ListItem , Text , Box } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { FaCheckCircle } from "react-icons/fa";



interface ServiceCardProps {
    icon: IconType;
    title: string;
    items: string[];
    colorScheme: string;
    bg: string;
    borderColor: string;
  }
  

  // Sub-components
  const ServiceCardDescriptor = ({ icon , title, items, colorScheme, bg, borderColor } : ServiceCardProps) => (
    <Box 
      p={6} 
      borderRadius="lg" 
      borderWidth="1px"
      borderColor={borderColor}
      bg={bg}
      height="100%"
    >
      <Heading size="md" mb={4} display="flex" alignItems="center" fontFamily="arial" >
        <Icon as={icon} color={`${colorScheme}.500`} mr={3} />
        {title}
      </Heading>
      <List spacing={3}>
        {items.map((item, index) => (
          <ListItem key={index} display="flex" alignItems="flex-start">
            <ListIcon as={FaCheckCircle} color="green.500" mt={1} />
            <Text>{item}</Text>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  export default ServiceCardDescriptor;